module.exports = __webpack_public_path__ + "static/media/er.e5e5e397.svg";